export enum RealEstateLevel {
    Group = 'group',
    Office = 'office',
    Agent = 'agent',
    Location = 'location',
}
